import { styled } from 'stitches.config'
import { ContentWrapper as ContentWrapperFeedGreat } from '../../../Startr/components/FeedGreat/FeedGreat.styles'
import { CustomMealPlanRoot } from '../../../FivePound/components/CustomMealPlan/CustomMealPlan.styles'

export const StartrMixinRoot = styled(CustomMealPlanRoot, {

})

export const ContentWrapper = styled(ContentWrapperFeedGreat, {
    alignItems: 'center',
    gap: '$2',
    padding: 0,
    justifyContent: 'unset',
    top: '100px',
   right: '8%',
   '@bp4': {
    right: '10%',
   }
})